<template>
  <div id="production-page">
    <div class="flex-grow my-4">
      <h1>{{ $t('Portfolio') }}</h1>
    </div>
    <div class="vx-card full-page">
      <grid-panel
        v-if="!loading"
        :column-defs="columnDefs"
        :url="url"
        :apiParams="apiParams"
        :loadOnRender="false"
        :gridOptions="gridOptions"
        @download="download"
        :defaultColDef="defaultColDef"
        :headerTextWrap="true"
        @update:gridApi="(gridApi) => this.gridApi = gridApi"
        rowSelection="multiple"
      >
        <template slot="right">
          <date-range-picker class="ml-4" @update:startDate="startDate = $event" @update:endDate="endDate = $event" />
          <grid-actions-menu class="ml-4 portfolio-actions-button">
            <vs-dropdown-item>
                <span
                    class="flex items-center"
                    @click="prepareMultiDownload"
                >
                  <v-icon name="download" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t('DownloadSelected') }}</span>
                </span>
            </vs-dropdown-item>
          </grid-actions-menu>
        </template>
      </grid-panel>
    </div>
  </div>
</template>

<script>
import GridPanel from '@/views/components/ag-grid/GridPanel';
import GridActionsMenu from "../../components/extra-components/GridActionsMenu";
import ProductionConfig from '@/grids/Production/ProductionConfig';
import DateRangePicker from "../../components/calendar/DateRangePicker";
import CellRendererDate from "../../components/ag-grid/cell-renderer/CellRendererDate";
import CellRendererDownload from "../../components/ag-grid/cell-renderer/CellRendererDownload";
import CellRendererCurrency from "../../components/ag-grid/cell-renderer/CellRendererCurrency";
import FileDownloadMixin from "../../../components/mixins/FileDownloadMixin";
import SetGridOptionsMixin from "@/components/mixins/SetGridOptionsMixin";
import ToolTipRenderer from '@/views/components/ag-grid/components/ToolTipRenderer';
import { TABLE_IDENTIFIER_FW_PORTFOLIO_ID } from '@/constants'
import moment from 'moment';

export default {
  components: {
    GridPanel,
    GridActionsMenu,
    DateRangePicker,
    CellRendererDate,
    CellRendererDownload,
    CellRendererCurrency,
    ToolTipRenderer,
  },
  mixins: [FileDownloadMixin, SetGridOptionsMixin],
  data() {
    return {
      url: (params) => this.$api.productions.list(params),
      gridApi: null,
      startDate: null,
      endDate: null,
      gridOptions: {},
      defaultColDef: {
        resizable: true,
        sortable: true,
        wrapText: true,
        tooltipComponent: 'ToolTipRenderer',
      },
      tableIdentifier: TABLE_IDENTIFIER_FW_PORTFOLIO_ID,
      loading: false,
    };
  },
  computed: {
    apiParams() {
      // Only set these when we have the full date range available
      // Otherwise it loads the endpoint twice and fails the first time due to missing parameters
      if (!this.startDate || !this.endDate) {
        return null;
      }

      return {
        startDate: (this.startDate) ? moment(this.startDate).format('YYYY-MM-DD') : null,
        endDate: (this.endDate) ? moment(this.endDate).format('YYYY-MM-DD') : null
      }
    },
    columnDefs() {
      return this.getColumnDefsWithWidths(ProductionConfig);
    }
  },
  methods: {
    prepareMultiDownload() {
      const selectedGuids = this.gridApi.getSelectedNodes().map((item) => {
        return item.data.DownloadCertificate;
      });
      const params = {
        documentType: 'policyCertificate',
        documentGuid: selectedGuids,
      }
      this.downloadConfirm(params);
    }
  }
};
</script>
<style lang="scss">
.portfolio-actions-button {
  min-width: 100.66px;
}
</style>
